import {initialLocale} from '@/translations';

export default () => {
	if (typeof window === 'undefined' || typeof serverVariables !== 'undefined') {
		return;
	}

	// @ts-ignore
	window.serverVariables = {
		environment: process.env.NODE_ENV,
		httpRequest: {
			absoluteUrl: window.location.href,
			path: window.location.pathname,
			baseUrl: window.location.origin,
			basePath: '/',
			applicationUrl: window.location.pathname.substring(1),
			applicationPath: window.location.pathname.substring(1).split('?')[0],
			origin: window.location.origin,
			createdByFacebookBot: false,
			locale: initialLocale
		}
	};
};
